<!-- eslint-disable vue/no-v-html -->
<template>
  <div :class="classesObject">
    <div class="sam-empty-state__body">
      <div
        v-if="image"
        class="col-xs-12 d-flex center-xs mb-2"
      >
        <SamImage
          :image="image"
          :image-height="imageHeight"
          class="sam-empty-state__image"
        />
      </div>
      <div
        v-if="hasTitle"
        class="col-xs-12 d-flex center-xs"
      >
        <h6
          class="sam-empty-state__title"
          v-text="title"
        />
      </div>
      <div
        v-if="subtitle"
        class="col-xs-12 d-flex center-xs"
      >
        <p
          class="sam-empty-state__subtitle"
          v-html="subtitle"
        />
      </div>
      <div
        v-if="hasBodySlot"
        class="col-xs-12 d-flex center-xs"
      >
        <slot name="body" />
      </div>
    </div>
    <div
      v-if="hasFooterSlot"
      class="sam-empty-state__footer"
    >
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import SamImage from '../SamImage/SamImage.vue';

export default {
  name: 'SamEmptyState',
  components: { SamImage },
  props: {
    /**
     * Empty state block's title
     */
    title: {
      type: String,
      default: '',
    },
    /**
     * Empty state block's subtitle
     */
    subtitle: {
      type: String,
      default: '',
    },
    /**
     * Image to apply
     */
    // eslint-disable-next-line vue/require-default-prop
    image: {
      type: String,
      required: false,
    },
    /**
     * Image height
     */
    imageHeight: {
      type: String,
      required: false,
      default: '',
    },
    innerVariation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classesObject() {
      return ['sam-empty-state', { 'is-compact': this.innerVariation }];
    },
    hasTitle() {
      return this.title.length;
    },
    hasBodySlot() {
      return !!this.$slots.body;
    },
    hasFooterSlot() {
      return !!this.$slots.footer;
    },
    cssStyle() {
      const style = {};

      if (this.imageHeight) {
        style['--image-height'] = this.imageHeight;
      }

      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
$border-color: $neutral--30;

.sam-empty-state {
  @extend .text--body-1, .px-6, .py-8;
  $parent: &;
  height: 100%;
  width: 100%;
  background: $primary--white;
  border: $size--0--fourth solid $border-color;
  border-radius: $size--1;

  &.is-compact {
    border: none;
    border-radius: 0;
    background: none;

    #{$parent}--body {
      padding: $size--0 5rem;
    }
  }

  &__subtitle {
    @extend .text--body-1;
    max-width: 66%;
  }

  &__body {
    @extend .d-flex;
    row-gap: $size--2;
    flex-direction: column;
  }

  &__image {
    max-width: 66%;
  }

  &__footer {
    @extend .d-flex, .center-xs, .mt-4;
  }
}

@media only screen and (max-width: 1024px) {
  .sam-empty-state__subtitle {
    max-width: 100%;
  }

  .sam-empty-state__image {
    max-width: 100%;
  }
}
</style>
